import Pdp34Layout from "@/sections/pdp-3-4/Pdp34Layout";
import { PDP_3_4 } from "@/data/pdp-3-4";

// Route: /pdp-concept-v3-4 (see App.js). Composition: src/sections/pdp-3-4/sections.js
export default function PdpConceptV34() {
  return <Pdp34Layout data={PDP_3_4} />;
}
